<style scoped>
    @import url("../../styles/mainV2/menuAbaixo.scss");
</style>

<template>
    <div class="box_menuAbaixo">

        <div class="enquadro_barra_util">
            
            <div 
            @mouseover="$store.state.flagMenuAbaixo = true"
            @mouseleave="$store.state.flagMenuAbaixo = false"
            class="enquadro_meio animate__animated animate__backInDown">
            <!-- animate__slideInDown -->

                <div class="box_content">
                    
                    <div class="content animate__animated animate__fadeIn mt-1 mb-1" 
                    v-for="(el,i) in $store.state.liAbaixo" :key="i"
                    @mouseover="changeColorItemMenu(i,'on')"
                    @mouseleave="changeColorItemMenu(i,'off')"
                    :style="{'background':el.b}"
                    @click="callPage(i)"
                    >
                        <span :style="{'color':el.cor}" class="ml-2">{{ el.t }}</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            /*
            liAbaixo:[
                {'t':'teste0','cor':'','b':'','r':'/'},
                {'t':'teste1','cor':'','b':'','r':'/'},
                {'t':'teste2','cor':'','b':'','r':'/'},
                {'t':'teste3','cor':'','b':'','r':'/'},
            ]*/
        }
    },

    methods: {
        changeColorItemMenu(i,strFlag) {
            //
            if (strFlag == 'on') {
                this.$store.state.liAbaixo[i].cor = 'rgb(31,122,177)'
                this.$store.state.liAbaixo[i].b = 'rgba(31,122,177,0.3)'
            } else {
                this.$store.state.liAbaixo[i].cor = ''
                this.$store.state.liAbaixo[i].b = ''
            }
        },
        callPage(i) {
            //console.log('[menu abaixo] i: ',i)
            //console.log('[menu abaixo] rota: ',this.$store.state.liAbaixo[i].r)
            if(this.$store.state.liAbaixo[i].r != '/') {
                
                this.$router.push(this.$store.state.liAbaixo[i].r)
                //console.log('[menu abaixo] teste: ')

                //this.$emit('callByMenuBody','close') // return emit String. (trocar icon menu)
                //this.$store.state.flagMenuSup = false
            }
        },
    },

    created() {
        //
        //console.log('[menu abaixo] this.$store.state.liAbaixo: ',this.$store.state.liAbaixo)
    }
}
</script>